import { render } from "./noticeInfo.vue?vue&type=template&id=54e456da&scoped=true"
import script from "./noticeInfo.vue?vue&type=script&lang=js"
export * from "./noticeInfo.vue?vue&type=script&lang=js"

import "./noticeInfo.vue?vue&type=style&index=0&id=54e456da&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e456da"]])

export default __exports__